/* R&R case gift picker v3 — qualifying 16 oz cases + real $0 gift line items. */
(() => {
  if (window.__rrCaseGiftV3Loaded) return;
  window.__rrCaseGiftV3Loaded = true;

  const GIFT_PREFIX = 'R&R Free Gift ';
  const MAX_GIFTS = 12;
  const GIFT_OPTIONS = [
    { key:'rubee', title:'Rubee Hand & Body Lotion - 2 oz', variantId:49852843851928, handle:'rubee-hand-body-lotion-4-oz', image:'https://cdn.shopify.com/s/files/1/0444/8128/2200/files/rubee-2oz-front.png?v=1744406035' },
    { key:'rinju', title:'Rinju Hand & Body Lotion - 2 oz', variantId:49852843884696, handle:'rinju-hand-body-lotion-2-oz', image:'https://cdn.shopify.com/s/files/1/0444/8128/2200/files/white-rinju-2oz-front.png?v=1738177523' },
    { key:'br', title:'Rinju Beauté Réelle Body and Hand Cream - 2 oz', variantId:49852843917464, handle:'rinju-beaute-reelle-body-and-hand-cream-2-oz', image:'https://cdn.shopify.com/s/files/1/0444/8128/2200/files/beaute-relle-2oz-front.png?v=1738177504' },
    { key:'plt', title:'Pierre La Touche Hand & Body Lotion - 2 oz', variantId:49852843950232, handle:'pierre-la-touche-hand-body-lotion-2-oz', image:'https://cdn.shopify.com/s/files/1/0444/8128/2200/files/p-la-touche-2oz-front.png?v=1738177514' }
  ];
  const VALID_GIFT_TITLES = new Set(GIFT_OPTIONS.map(option => option.title));
  const GIFT_VARIANT_IDS = new Set(GIFT_OPTIONS.map(option => String(option.variantId)));
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
  let busy = false;
  let reconcilePromise = null;
  let currentCart = null;
  let activeSlot = 1;
  let lastFocus = null;
  let suppressionQueued = false;

  const safeSessionGet = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const safeSessionSet = (key,value) => { try { sessionStorage.setItem(key,value); } catch {} };
  const safeSessionRemove = key => { try { sessionStorage.removeItem(key); } catch {} };

  async function fetchJson(url, options = {}, timeoutMs = 12000) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), timeoutMs);
    try {
      const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options,signal:controller.signal});
      let payload = null;
      try { payload = await response.json(); } catch {}
      if (!response.ok) throw new Error(payload?.description || payload?.message || 'We couldn’t update your gift. Try again.');
      return payload;
    } finally { clearTimeout(timeout); }
  }

  const getCart = () => fetchJson(`${rootPath()}cart.js`,{headers:{Accept:'application/json'}});
  const updateAttributes = changes => fetchJson(`${rootPath()}cart/update.js`,{
    method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:changes})
  });
  const changeLine = (key,quantity=0) => fetchJson(`${rootPath()}cart/change.js`,{
    method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})
  });
  const addGiftLine = (option,slot) => fetchJson(`${rootPath()}cart/add.js`,{
    method:'POST',
    headers:{'Content-Type':'application/json',Accept:'application/json'},
    body:JSON.stringify({items:[{
      id:option.variantId,
      quantity:1,
      properties:{
        '_rr_free_gift':'1',
        '_rr_gift_slot':String(slot),
        'FREE GIFT':'PACK THIS 2 OZ'
      }
    }]})
  });

  function isExact16ozTitle(title='') {
    return /(?:^|[^0-9.])16\s*(?:fl\.?\s*)?oz\b/i.test(String(title));
  }

  function isGiftLine(item) {
    return GIFT_VARIANT_IDS.has(String(item?.variant_id || item?.id || ''));
  }

  function isQualifyingItem(item) {
    if (isGiftLine(item)) return false;
    const product = String(item?.product_title || item?.title || '');
    const variant = String(item?.variant_title || '');
    if (!isExact16ozTitle(product)) return false;
    if (/\bjars?\b/i.test(product) || /\bjars?\b/i.test(variant)) return false;
    return true;
  }

  function packUnits(item) {
    const variant = String(item?.variant_title || '');
    const product = String(item?.product_title || item?.title || '');
    let match = variant.match(/\b(\d+)\s*(?:Bottle|Bottles|Pack|Set)\b/i);
    if (!match) match = product.match(/\b(\d+)[-\s]?(?:Pack|Bottles|Bottle|Set)\b/i);
    const units = match ? Number(match[1]) : 1;
    return Number.isFinite(units) && units > 0 ? units : 1;
  }

  function qualifyingUnits(cart) {
    return (cart?.items || []).reduce((sum,item) => {
      if (!isQualifyingItem(item)) return sum;
      return sum + (packUnits(item) * Math.max(0,Number(item.quantity)||0));
    },0);
  }
  const entitlement = cart => Math.max(0,Math.floor(qualifyingUnits(cart)/12));
  const giftKey = index => `${GIFT_PREFIX}${index}`;

  function selectedGifts(cart,max=entitlement(cart)) {
    const attrs = cart?.attributes || {};
    const gifts = [];
    for (let i=1;i<=Math.min(max,MAX_GIFTS);i++) {
      const value = String(attrs[giftKey(i)] || '').trim();
      gifts.push(VALID_GIFT_TITLES.has(value) ? value : '');
    }
    return gifts;
  }
  function firstMissingSlot(cart) {
    const missing = selectedGifts(cart).findIndex(value => !value);
    return missing === -1 ? null : missing + 1;
  }
  function cartSignature(cart) {
    return `${qualifyingUnits(cart)}:${entitlement(cart)}:${selectedGifts(cart).filter(Boolean).length}`;
  }
  const dismissKey = cart => `rr-gift-dismissed:${cartSignature(cart)}`;

  function giftLineSlot(item) {
    const raw = String(item?.properties?._rr_gift_slot || '');
    const slot = Number(raw);
    return Number.isInteger(slot) && slot >= 1 && slot <= MAX_GIFTS ? slot : null;
  }
  function optionForTitle(title) { return GIFT_OPTIONS.find(option => option.title === title) || null; }
  function giftLines(cart) { return (cart?.items || []).filter(isGiftLine); }

  function cleanupLegacyGiftLayer() {
    document.querySelectorAll('.rr-reward-backdrop').forEach(el => el.remove());
    document.body?.classList.remove('rr-gift-open');
    document.documentElement.classList.remove('rr-gift-open');
    document.body?.style.removeProperty('filter');
    document.body?.style.removeProperty('backdrop-filter');
    document.body?.style.removeProperty('-webkit-backdrop-filter');
  }
  function suppressLegacyGiftWidget() {
    cleanupLegacyGiftLayer();
    document.querySelectorAll('[class*="salepify" i],[id*="salepify" i]').forEach(el => el.classList.add('rr-salepify-gift-suppressed'));
  }
  function queueSuppression() {
    if (suppressionQueued) return;
    suppressionQueued = true;
    requestAnimationFrame(() => { suppressionQueued = false; suppressLegacyGiftWidget(); });
  }

  function ensurePicker() {
    let shell = document.getElementById('rr-case-gift-picker');
    if (shell) return shell;
    shell = document.createElement('div');
    shell.id = 'rr-case-gift-picker';
    shell.className = 'rr-case-gift';
    shell.hidden = true;
    shell.setAttribute('aria-hidden','true');
    shell.innerHTML = `
      <button type="button" class="rr-case-gift__overlay" data-rr-gift-close aria-label="Close free gift picker"></button>
      <section class="rr-case-gift__panel" role="dialog" aria-modal="true" aria-labelledby="rr-case-gift-title">
        <div class="rr-case-gift__handle" aria-hidden="true"></div>
        <header class="rr-case-gift__head">
          <div><p class="rr-case-gift__eyebrow">YOUR FREE GIFT</p><h2 id="rr-case-gift-title">Pick your 2 oz.</h2><p class="rr-case-gift__support" data-rr-gift-support></p></div>
          <button type="button" class="rr-case-gift__close" data-rr-gift-close aria-label="Close free gift picker">×</button>
        </header>
        <div class="rr-case-gift__body"><p class="rr-case-gift__slot" data-rr-gift-slot></p><div class="rr-case-gift__grid" data-rr-gift-grid></div><p class="rr-case-gift__error" data-rr-gift-error role="alert" hidden></p></div>
      </section>`;
    document.body.append(shell);
    shell.addEventListener('click',event => {
      if (event.target.closest('[data-rr-gift-close]')) { closePicker(true); return; }
      const choice = event.target.closest('[data-rr-gift-choice]');
      if (choice && !busy) chooseGift(choice.dataset.rrGiftChoice);
    });
    document.addEventListener('keydown',event => {
      if (event.key === 'Escape' && shell.classList.contains('is-open')) closePicker(true);
    });
    return shell;
  }

  function setBusy(next) {
    busy = !!next;
    const shell = ensurePicker();
    shell.classList.toggle('is-busy',busy);
    shell.querySelectorAll('[data-rr-gift-choice]').forEach(button => { button.disabled = busy; });
  }
  function showError(message) {
    const note = ensurePicker().querySelector('[data-rr-gift-error]');
    note.hidden = !message;
    note.textContent = message || '';
  }

  function renderPicker(cart,slot=firstMissingSlot(cart)||1) {
    currentCart = cart;
    const earned = entitlement(cart);
    activeSlot = Math.min(Math.max(1,slot),Math.max(1,earned));
    const shell = ensurePicker();
    const units = qualifyingUnits(cart);
    shell.querySelector('[data-rr-gift-support]').textContent = earned === 1
      ? `You earned 1 free 2 oz with ${units} qualifying full-size units.`
      : `You earned ${earned} free 2 oz gifts with ${units} qualifying full-size units.`;
    shell.querySelector('[data-rr-gift-slot]').textContent = earned > 1 ? `Gift ${activeSlot} of ${earned}` : 'Choose one on us.';
    const grid = shell.querySelector('[data-rr-gift-grid]');
    grid.replaceChildren();
    const selected = selectedGifts(cart,earned);
    GIFT_OPTIONS.forEach(option => {
      const card = document.createElement('article');
      card.className = 'rr-case-gift__card';
      const repeat = selected.some((value,index) => value === option.title && index !== activeSlot-1);
      card.innerHTML = `<div class="rr-case-gift__media"><img src="${option.image}" alt="${option.title}" loading="eager"></div><h3>${option.title.replace(' - 2 oz','')}</h3><p>2 oz</p><button type="button" class="rr-case-gift__choose" data-rr-gift-choice="${option.key}">${selected[activeSlot-1] === option.title ? 'Selected' : (repeat ? 'Choose again' : 'Choose')}</button>`;
      grid.append(card);
    });
    showError('');
  }

  function openPicker(cart=currentCart,slot=null) {
    if (!cart || entitlement(cart) < 1) return false;
    renderPicker(cart,slot || firstMissingSlot(cart) || 1);
    const shell = ensurePicker();
    lastFocus = document.activeElement;
    shell.hidden = false;
    shell.style.removeProperty('pointer-events');
    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden','false');
    document.body.classList.add('rr-case-gift-open');
    document.dispatchEvent(new CustomEvent('rr:gift-open'));
    requestAnimationFrame(() => shell.querySelector('[data-rr-gift-close]')?.focus());
    return true;
  }

  function closePicker(userDismissed=false) {
    const shell = document.getElementById('rr-case-gift-picker');
    if (!shell) return;
    if (userDismissed && currentCart) safeSessionSet(dismissKey(currentCart),'1');
    shell.classList.remove('is-open','is-busy');
    shell.setAttribute('aria-hidden','true');
    document.body.classList.remove('rr-case-gift-open');
    document.dispatchEvent(new CustomEvent('rr:gift-close'));
    window.setTimeout(() => {
      if (!shell.classList.contains('is-open')) { shell.hidden = true; shell.style.pointerEvents = 'none'; }
    },330);
    lastFocus?.focus?.({preventScroll:true});
  }

  async function normalizeGiftLines(cart) {
    let latest = cart || await getCart();
    const earned = entitlement(latest);
    const selected = selectedGifts(latest,earned);
    const lines = giftLines(latest);
    const keptSlots = new Set();
    const removals = [];

    for (const line of lines) {
      const slot = giftLineSlot(line);
      const marked = String(line?.properties?._rr_free_gift || '') === '1';
      const chosenTitle = slot ? selected[slot-1] : '';
      const chosenOption = chosenTitle ? optionForTitle(chosenTitle) : null;
      const correctVariant = chosenOption && String(line.variant_id) === String(chosenOption.variantId);
      const valid = marked && slot && slot <= earned && chosenOption && correctVariant && !keptSlots.has(slot);
      if (!valid) {
        removals.push(line.key);
      } else {
        keptSlots.add(slot);
        if (Number(line.quantity) !== 1) {
          await changeLine(line.key,1);
          await sleep(40);
        }
      }
    }

    for (const key of removals) {
      await changeLine(key,0);
      await sleep(40);
    }

    if (removals.length) latest = await getCart();

    for (let slot=1; slot<=earned; slot++) {
      const title = selected[slot-1];
      if (!title) continue;
      const option = optionForTitle(title);
      if (!option) continue;
      const exists = giftLines(latest).some(line =>
        String(line?.properties?._rr_free_gift || '') === '1' &&
        giftLineSlot(line) === slot &&
        String(line.variant_id) === String(option.variantId) &&
        Number(line.quantity) === 1
      );
      if (!exists) {
        await addGiftLine(option,slot);
        await sleep(60);
        latest = await getCart();
      }
    }
    return latest;
  }

  async function chooseGift(optionKey) {
    const option = GIFT_OPTIONS.find(item => item.key === optionKey);
    if (!option || !currentCart || entitlement(currentCart) < activeSlot) return;
    setBusy(true); showError('');
    try {
      let updated = await updateAttributes({[giftKey(activeSlot)]:option.title});
      await sleep(60);
      updated = await normalizeGiftLines(await getCart().catch(() => updated));
      currentCart = updated;
      safeSessionRemove(dismissKey(updated));
      document.dispatchEvent(new CustomEvent('rr:cart-updated',{detail:{cart:updated,source:'gift-selection'}}));
      renderAllSummaries(updated);
      const next = firstMissingSlot(updated);
      if (next) renderPicker(updated,next); else closePicker(false);
    } catch (error) {
      showError(error?.name === 'AbortError' ? 'Saving your gift took too long. Try again.' : (error?.message || 'We couldn’t save your gift. Try again.'));
    } finally { setBusy(false); }
  }

  function cleanupChangesFor(cart) {
    const earned = entitlement(cart);
    const attrs = cart?.attributes || {};
    const changes = {};
    for (let i=1;i<=MAX_GIFTS;i++) {
      const key = giftKey(i);
      const value = String(attrs[key] || '').trim();
      if (!value) continue;
      if (i > earned || !VALID_GIFT_TITLES.has(value)) changes[key] = '';
    }
    return changes;
  }

  async function reconcile(cart,{openIfNeeded=true}={}) {
    if (reconcilePromise) return reconcilePromise;
    reconcilePromise = (async () => {
      let latest = cart || await getCart();
      const changes = cleanupChangesFor(latest);
      if (Object.keys(changes).length) {
        latest = await updateAttributes(changes);
        await sleep(60);
        latest = await getCart().catch(() => latest);
      }
      latest = await normalizeGiftLines(latest);
      currentCart = latest;
      renderAllSummaries(latest);
      const missing = firstMissingSlot(latest);
      let opened = false;
      if (openIfNeeded && missing && safeSessionGet(dismissKey(latest)) !== '1') opened = openPicker(latest,missing);
      if (!entitlement(latest)) closePicker(false);
      return {cart:latest,opened};
    })().finally(() => { reconcilePromise = null; });
    return reconcilePromise;
  }

  function renderSummaryInto(mount,cart) {
    const earned = entitlement(cart);
    if (!earned) { mount.replaceChildren(); mount.hidden = true; return; }
    mount.hidden = false;
    const gifts = selectedGifts(cart,earned);
    const selectedCount = gifts.filter(Boolean).length;
    const wrapper = document.createElement('section');
    wrapper.className = 'rr-gift-summary-card';
    const head = document.createElement('div');
    head.className = 'rr-gift-summary-card__head';
    head.innerHTML = `<div><p>FREE GIFT</p><strong>${earned === 1 ? '1 gift earned' : `${earned} gifts earned`}</strong></div>`;
    const change = document.createElement('button');
    change.type = 'button'; change.className = 'rr-gift-summary-card__change';
    change.textContent = selectedCount === earned ? 'Change' : 'Choose';
    change.addEventListener('click',() => openPicker(cart,firstMissingSlot(cart)||1));
    head.append(change); wrapper.append(head);
    const list = document.createElement('div'); list.className = 'rr-gift-summary-card__list';
    gifts.forEach((gift,index) => {
      const row = document.createElement('button'); row.type='button'; row.className='rr-gift-summary-card__row';
      row.innerHTML = `<span>Gift ${index+1}</span><strong>${gift || 'Choose your 2 oz'}</strong>`;
      row.addEventListener('click',() => openPicker(cart,index+1)); list.append(row);
    });
    wrapper.append(list);
    const note = document.createElement('p'); note.className='rr-gift-summary-card__note'; note.textContent='Added to your order at $0.00 and sent to fulfillment.'; wrapper.append(note);
    mount.replaceChildren(wrapper);
  }
  function renderAllSummaries(cart) {
    document.querySelectorAll('[data-rr-gift-summary]').forEach(mount => renderSummaryInto(mount,cart));
  }
  async function afterCartMutation(cart) {
    const result = await reconcile(cart,{openIfNeeded:true});
    return !!result.opened;
  }

  document.addEventListener('rr:cart-rendered',event => { const cart=event.detail?.cart || currentCart; if (cart) renderAllSummaries(cart); });
  document.addEventListener('rr:cart-updated',event => {
    if (event.detail?.source === 'gift-selection' || event.detail?.source === 'cart-bridge') return;
    const cart = event.detail?.cart;
    if (cart) reconcile(cart,{openIfNeeded:false}).catch(()=>{});
    else getCart().then(fresh => reconcile(fresh,{openIfNeeded:true})).catch(()=>{});
  });
  window.addEventListener('pageshow',() => { cleanupLegacyGiftLayer(); getCart().then(cart => reconcile(cart,{openIfNeeded:false})).catch(()=>{}); });

  const legacyObserver = new MutationObserver(queueSuppression);
  function init() {
    ensurePicker(); suppressLegacyGiftWidget();
    legacyObserver.observe(document.body,{subtree:true,childList:true});
    getCart().then(cart => reconcile(cart,{openIfNeeded:true})).catch(()=>{});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();

  window.RRCaseGift = {
    afterCartMutation,reconcile,renderAllSummaries,open:openPicker,close:closePicker,
    qualifyingUnits,entitlement,selectedGifts,isQualifyingItem,isGiftLine,giftLines
  };
})();
